/* eslint-disable */
import { createStore } from 'vuex'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'

const initialState = {
    isAppLoaded: false
}

import auth from './modules/auth'
import menu from './modules/menu'
import nps from './modules/nps'
import contact from './modules/contact'
import cart from './modules/cart'
import order from './modules/order'
import musique from './modules/musique'
import restaurant from './modules/restaurant'


export default createStore({
    // strict: true,
    state: initialState,

    getters,
    mutations,
    actions,


    modules: {
        auth,
        menu,
        nps,
        contact,
        cart,
        order,
        musique,
        restaurant

    }
})